import { ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { ImageGalleryProps } from 'components/ImageGallery';
import { getAnchorId } from 'src/utils/getAnchorId';
import { TableOfContentsComponentRendering } from '../types/TableOfContentsComponentRendering';

type ImageGalleryComponentRendering = {
  component: ComponentRendering & ImageGalleryProps;
  handleIsIntersection: (anchorId: string) => void;
};

/**
 * Enrich the image gallery component with the anchor id and the title.
 * We return this data as additional fields to the component so it can't conflict with the other props of the component.
 * @param component - The image gallery component.
 * @param handleIsIntersection - The function to set the intersecting.
 * @returns The enriched image gallery component.
 */
export const enrichImageGallery = ({
  component,
  handleIsIntersection,
}: ImageGalleryComponentRendering) => {
  const title = component?.fields?.title?.value?.toString() ?? '';
  const anchorId = getAnchorId(title);

  return {
    ...component,
    additionalFields: {
      tableOfContentItem: {
        title: title,
        anchorId,
        isActive: false,
      },
      anchor: anchorId,
      isContained: true,
      isIntersecting: handleIsIntersection,
    },
  } as TableOfContentsComponentRendering<ComponentRendering>;
};
